import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import { Box, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import WalletList from './WalletList';

const ExpertWalletIndex = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'expert-wallet'
        });
    }, []);
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState('0');
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    }
  return (
    <>
        <PageHeaderLayout headerTitle={`Manage Expert's Wallet`}>
            {/* <Box sx={{display:{xs:'none',sm:'flex',gap:'2%'}}}>
                <Button variant='contained' onClick={() => window.open(`/admin/experts-map`,'blank')} size='small' sx={{ py: '2px',width: {
                    xs: '-webkit-fill-available', // full available width on mobile
                    //   sm: 'auto' // shrink on larger screens
                    } }} endIcon={<Map />}>
                View Map
            </Button>
            <PermissionGuard feature='service-expert' permission='canCreate'>
                <Button variant='contained' onClick={() => navigate(`/admin/userProfile/0`)} size='small' sx={{ py: '2px',width:{xs:'100%',sm:'auto'} }} endIcon={<AddCircle />}>
                    Add
                </Button>                    
            </PermissionGuard>
            
            </Box> */}
            <Button variant='contained' onClick={() => navigate(-1)} size='small' endIcon={<ArrowBack />} sx={{ml:'.25% !important'}}>
                Back
            </Button>
        </PageHeaderLayout>
        <WalletList  />
    </>
  )
}

export default ExpertWalletIndex
